module.exports = __webpack_public_path__ + "img/paypal-gateway.613af518.svg";